import React, { useContext, useState } from 'react';
import styles from './styles.module.scss';
import Form from '../Form';
import AppFormInput from '../AppFormInput';
// import Api from '@/api/index';
import Api from '../../api';
// import CheckNumeric from '@/functions/CheckNumeric';
// import AppImage from '../AppImage';
import warning from '../../../../assets/imgs/login/warning.svg';
import CheckNumericType from '../../functions/CheckNumeric';
import { AdminContext } from '../../context/AdminContext';

// import AppImage from '../AppImage';

const ForgetPasswordCode = ({ setLevel2, setLevel3, newuser }) => {
  const [user, setUser] = useState(newuser);
  const [showErrorcode, setShowErrorcode] = useState(false);
  const [serverError, setServerError] = useState('');
  const [pressEnter, setPressEnter] = useState(false);
  const [loading, setLoading] = useState(false);
  const { content } = useContext(AdminContext);

  const changeUsercode = (e) => {
    setUser({ ...newuser, code: e.target.value });
    setServerError('');
    setShowErrorcode(false);
    setPressEnter(false);
  };

  const submitFormFunction = (e) => {
    e.preventDefault();
    if (pressEnter == false) {
      setPressEnter(true);

      let check;
      check = CheckNumericType(user.code);
      if (check == false || user?.code?.length !== 4) {
        setShowErrorcode(true);
      } else {
        setShowErrorcode(false);
        setLoading(true);
        Api.userForgetPassword({
          username: `${newuser?.mobile}`,
          code: `${user?.code}`,
          countryCode: '+' + `${newuser?.countryCode}`,
        })
          .then((res) => {
            setLevel2(false);
            setLevel3(true);
            setLoading(false);
            setPressEnter(false);
          })
          .catch((err) => {
            setServerError(err?.response?.data?.message);
            setLoading(false);
            setPressEnter(false);
          });
      }
    }
  };

  return (
    <div className={`${styles.container}`}>
      {serverError !== '' && (
        <div className={styles.serverError}>
          {/* <AppImage
            src={warning}
            alt="warning"
            width={20}
            height={20}
            // containerclassName="flex flex-row justify-center items-center"
          /> */}
          <span>{serverError}</span>
        </div>
      )}
      <p className={styles.title}>{content?.forgetPassword?.code?.title}</p>
      <p className={styles.text}>
        {content?.forgetPassword?.code?.description}
      </p>
      <Form
        onSubmit={submitFormFunction}
        extraClassName="h-[180px] w-full"
        extraStyleButton={{ marginBottom: '0' }}
        user={user}
        buttonText={content?.forgetPassword?.code?.button}
        loadingU={loading}
        extraButtonClass={styles.formButton}
      >
        <AppFormInput
          targetType="num"
          onChange={changeUsercode}
          inputWidth="420px"
          inputStyle={styles.inputStyle}
          showError={showErrorcode}
          title={content?.forgetPassword?.code?.input?.title}
          error={content?.forgetPassword?.code?.input?.error}
          wrapperStyle={`${styles.wrapper} borderBottom`}
          className={styles.inputContainer}
          value={user?.code}
        />
      </Form>
    </div>
  );
};

export default ForgetPasswordCode;
